import { render, staticRenderFns } from "./person_auth_table.vue?vue&type=template&id=48574fe1&scoped=true"
import script from "./person_auth_table.vue?vue&type=script&lang=ts"
export * from "./person_auth_table.vue?vue&type=script&lang=ts"
import style0 from "./person_auth_table.vue?vue&type=style&index=0&id=48574fe1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48574fe1",
  null
  
)

export default component.exports